import React from "react"
import {useState} from 'react';
import axios from 'axios';
import {Button, Modal, Form, Dropdown, ButtonGroup} from 'react-bootstrap';
import {PencilSquare} from 'react-bootstrap-icons';
import '../estilos/AddNegocio.css';
import SelectParam from "./selectores/SelectParam";

function EditTipoParam (props) {
  //console.log('EdittipoParam: ', props.nombre_tabla)
  let elemento = "";
  let id_epp = "";
  let nombre_epp = "";
  let tabla_tipo_epp = "";
  if (props.nombre_tabla.indexOf("/") >= 0) {
    var k = props.nombre_tabla.split("/")
    //elemento = k[0];
    //id_epp = k[1];
    nombre_epp = k[1];
    tabla_tipo_epp = k[2];
  };

  let valor = '';
  props.columnas.map((e) => {return e.accessor;}).forEach(function(e, idx) {
    //console.log('tColumna', response.data.headers[idx])
    if (!valor.substring(0,6) == 'estado') {
      if (valor === ''){
        valor=valor.concat('"',e,'":""');
      }else {
        valor=valor.concat(',"',e,'":""');
      }
    }
  })
  valor="{".concat(valor, "}")

  const [formEpp, setFormEpp] = useState(JSON.parse(valor));
  const [formEppError, setFormEppError] = useState(JSON.parse(valor));
  const [formConError, setFormConError] = useState();

  const campos = props.columnas.map((e) => {return e.accessor;}).filter((e) => {return e.substring(0,3) !== "max";}).map((f) => {return f;});

  //console.log('props.columnas',  props.columnas);
  //console.log('Campos', campos);
  const [show, setShow] = useState(false);

  //const handleClose = () => setShow(false);
  //const handleShow = () => setShow(true);

  function cambioEnForm (event) {
    const {value, name} = event.target;
    setFormEpp(prevNote => ({...prevNote, [name]: value}))
    setFormConError(null);
    //console.log('cambio en form')
  }

  function handleClose () {
    setShow(false);
  }
  function handleShow () {
    //setFormEpp(JSON.parse(valor));
    //setFormEppError(JSON.parse(valor));

    setFormConError(null);
    setShow(true);
  }

  function grabaForm () {
    //console.log(formEpp);
    let hay = false;
    for (const [key, value] of Object.entries(formEpp)) {
      //console.log(`${key}: ${value}`);
        if (!value) {
          hay = true;
          setFormConError(key);
        }
    }
    if (!hay) {
      //no hay errores, grabar el dato
      const dataForm = {
        tabla_tipo: tabla_tipo_epp,
        datos: JSON.stringify(formEpp),
      }
      //console.log(dataForm);
      axios({
        method: "POST",
        url:"/api/grabatipoepp",
        data: dataForm
      })
      .then((response) => {
        //console.log('axios: ', response.data.datos);
      }).catch((error) => {
        if (error.response) {
          //console.log(error.response)
          //console.log(error.response.status)
          //console.log(error.response.headers)
          }
      });
      const aleatorio = Math.floor(Math.random()*1000).toString()
      setShow(false); //cierra la ventana popup
      props.setRuta('/paramrefresca'.concat('_',aleatorio,props.nombre_tabla));

    }
    //setShow(false);
  }

  return (
    <>
      <button class="btn btn-outline-primary" size="sm" onClick={handleShow}><PencilSquare /></button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><h3>Agregar {nombre_epp}</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
              {nombre_epp==='patron'?
              <>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label><span className="campo">Descripción</span></Form.Label>
                  <Form.Control
                    name="descripcion"
                    type="text"
                    placeholder="Descripción"
                    onChange={cambioEnForm}
                    autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label><span className="campo">Marca</span></Form.Label>
                  <Form.Control
                    name="nombre_marca"
                    type="text"
                    placeholder="Marca"
                    onChange={cambioEnForm}
                    autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label><span className="campo">Modelo</span></Form.Label>
                  <Form.Control
                    name="modelo"
                    type="text"
                    placeholder="Modelo"
                    onChange={cambioEnForm}
                    autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label><span className="campo">Serie</span></Form.Label>
                  <Form.Control
                    name="serie"
                    type="text"
                    placeholder="Serie 8"
                    onChange={cambioEnForm}
                    autoFocus
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="id marca">
                  <Form.Label><span className="campo">Seleccione mes calibración {nombre_epp}</span>
                  </Form.Label>
                    <Form.Select aria-label="Default select example" name="mes_calibracion"  onChange={cambioEnForm}>
                      <SelectParam parametro="mes_calibracion" />
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="id marca">
                  <Form.Label><span className="campo">Seleccione período calibración {nombre_epp}</span>
                  </Form.Label>
                    <Form.Select aria-label="Default select example" name="periodo_calibracion"  onChange={cambioEnForm}>
                      <SelectParam parametro="periodo_calibracion" />
                    </Form.Select>
                </Form.Group>
              </>:
              null
              
              }
              {nombre_epp==='tecnico'?
              <>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label><span className="campo">Nombre Técnico</span></Form.Label>
              <Form.Control
                name="tecnico_ensayo"
                type="text"
                placeholder="Nombre"
                onChange={cambioEnForm}
                autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label><span className="campo">Comentario</span></Form.Label>
              <Form.Control
                name="comentario"
                type="text"
                placeholder="Comentario"
                onChange={cambioEnForm}
                autoFocus
                />
              </Form.Group>
              </>
              :null
              }
          </Form>
          {formConError?<p><span className = "mensaje-error">{"Complete el valor de ".concat(formConError)}</span></p>:null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={grabaForm}>
            Grabar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

};

export default EditTipoParam;